import { getInterface } from '@/utils/js/initVariable';
const prefixUrl = 'api/UserWorkspaceApi/';
export const queryWorkspaceList = (data)=>{
  return getInterface.post(`${prefixUrl}queryWorkspaceList`, data);
}
export const putWorkspace = (data)=>{
  return getInterface.post(`${prefixUrl}putWorkspace`, data);
}
export const delWorkspace = (data)=>{
  return getInterface.post(`${prefixUrl}delWorkspace/${data}`, {});
}
// 快照 - 数据
export const queryUserWorkspaceDataList = (data)=>{
  return getInterface.post(`${prefixUrl}queryUserWorkspaceDataList/${data}`, {});
}
export const loadUserWorkspaceData = (data)=>{
  return getInterface.post(`${prefixUrl}loadUserWorkspaceData`, data);
}
export const delUserWorkspaceData = (data)=>{
  return getInterface.post(`${prefixUrl}delUserWorkspaceData/${data}`, {});
}
export const queryUserWorkspaceDataDetail = (data)=>{
  return getInterface.post(`${prefixUrl}queryUserWorkspaceDataDetail/${data}`, {});
}
export const saveUserWorkspaceData = (data)=>{
  return getInterface.post(`${prefixUrl}saveUserWorkspaceData`, data);
}
export const publishFootPrintMap = (data)=>{
  return getInterface.post(`${prefixUrl}publishFootPrintMap`, data);
}

// 快照任务
// 查询快照任务List
export const getAllTasks = (data)=>{
  return getInterface.post(`${prefixUrl}getAllTasks`, data);
}
// 新增/修改任务
export const addTask = (data)=>{
  return getInterface.post(`${prefixUrl}addTask`, data);
}
// 暂停任务
export const pauseTask = (data)=>{
  return getInterface.post(`${prefixUrl}pauseTask/${data}`, {});
}
// 恢复任务
export const resumeTask = (data)=>{
  return getInterface.post(`${prefixUrl}resumeTask/${data}`, {});
}
// 删除任务
export const deleteTask = (data)=>{
  return getInterface.post(`${prefixUrl}deleteTask/${data}`, {});
}
// 轨迹裁剪
export const clipTrajectory = (data)=>{
  return getInterface.post(`${prefixUrl}clipTrajectory`, data);
}